import { render, staticRenderFns } from "./BuildCarrier.vue?vue&type=template&id=17e1b3a4&scoped=true&"
import script from "./BuildCarrier.vue?vue&type=script&lang=js&"
export * from "./BuildCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1b3a4",
  null
  
)

export default component.exports